
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.088 22.78a1.86 1.86 0 100 3.72 1.86 1.86 0 100-3.72zm0 2.8a.93.93 0 11.93-.93.93.93 0 01-.93.93zm-1.86-23.245h1.86a.47.47 0 00.403-.232.465.465 0 000-.465.46.46 0 00-.403-.232h-1.86a.47.47 0 00-.403.232.465.465 0 000 .465.46.46 0 00.403.232zm3.26 0h.465a.465.465 0 100-.93h-.465a.465.465 0 100 .93zM2.02 17.255a6.525 6.525 0 002.163 1.37v7.222a2.05 2.05 0 002.048 2.048h11.7a2.05 2.05 0 002.048-2.048v-23.8A2.05 2.05 0 0017.943 0H6.232a2.05 2.05 0 00-2.048 2.048V6.48a6.49 6.49 0 00-3.947 4.338A6.49 6.49 0 001.4 16.566a4.96 4.96 0 00.62.69zM6.232.93h11.7a1.12 1.12 0 011.119 1.118V2.8H5.114v-.742A1.12 1.12 0 016.232.93zm-5.3 11.623a5.59 5.59 0 013.875-5.311l.222-.062.26-.067.227-.045.3-.046.2-.022.506-.026a5.58 5.58 0 015.579 5.579 5.58 5.58 0 01-5.579 5.579 5.29 5.29 0 01-.506-.026l-.2-.022-.3-.046-.227-.045-.26-.067-.222-.062A5.59 5.59 0 01.93 12.552zm4.8 6.456c.033 0 .066.012.1.015a6.51 6.51 0 100-12.942c-.034 0-.066.01-.1.015a4.96 4.96 0 00-.581.1h-.023V3.72h13.947v17.667H5.114V18.9h.023a5.38 5.38 0 00.581.099zm12.225 7.956H6.232a1.12 1.12 0 01-1.118-1.118v-3.53H19.06v3.53a1.12 1.12 0 01-1.118 1.118zM8.83 10.98a.6.6 0 00-.734 0l-2.3 2-.767-1.067a.527.527 0 00-.867.6l1.1 1.534a.46.46 0 00.367.2h.067a.39.39 0 00.334-.133l2.735-2.4a.53.53 0 00.065-.734z"}})])
          )
        }
      }
    